import React from 'react';
import { injectIntl } from 'react-intl';

import ListFilterAsyncMultiple from 'components/layout/list/ListFilterAsyncMultiple';

class ListFilterLocation extends React.Component {
  listItemFormatter = location => {
    return (
      <>
        <b className="ws-normal">{location.name}</b>
        <br />
        <span class="small">
          {location.street} {location.house_number} {location.apartment_number}
          <br />
          {location.zip_code} {location.city}
        </span>
      </>
    );
  };

  listItemStringFormatter = location => `${location.name}, ${location.street}, ${location.city}`;

  listItemId = location => location.location_id;

  render() {
    const {
      intl: { messages },
    } = this.props;

    return (
      <ListFilterAsyncMultiple
        title={messages.location}
        listName="companyLocations"
        listUrl="/api/whitelabellocations.json"
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        listItemStringFormatter={this.listItemStringFormatter}
        paramName="location"
        complete
      />
    );
  }
}
ListFilterLocation.defaultProps = {};

export default injectIntl(ListFilterLocation);
